module.exports = __webpack_public_path__ + "media/3.a587a04a.mp3";